import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import { BASE_URL, OPERATE_CAR_OPERKIND, OPERATE_FILTER, OPERKIND_CAR } from "../../../constant-value";
import CardServicesView from "./card-service-vw";
import { HashLoader } from "react-spinners";
import { IoOptionsOutline } from "react-icons/io5";
import BottomSheet from "../../bottom-sheet/bottom-sheet";
import Filter from "../filter/filter";
import { useDispatch, useSelector } from "react-redux";
import { selectCars } from "../../../redux/car/car-slice";
import { resetDeleteState, selectDeleteOperateSuccessState, selectDelLoadingState } from "../../../redux/operate/operate-delete-slice";
import { toast, ToastContainer } from "react-toastify";
import api from "../../../services/axiosConfig";
import ErrorBox from "../../pages/errorBox";
import SpinnerWrapper from "../../pages/spinnerWrapper";
import { PuffLoader } from "react-spinners";
import { calculateDateDiff } from '../../../conponents/pages/dateDiff';
import { motion } from "framer-motion";


const ShowAll = () => {
  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, sethasError] = useState(false);
  const [openFilterPage, setOpenFilterPage] = useState(false);
  const cars = useSelector(selectCars);
  const isDeleteLoading = useSelector(selectDelLoadingState);
  
  function handleDataFromChild(getData) {
    setIsLoading(true);
    var params = new URLSearchParams();

    params = "1==1"
    if (getData.carId && getData.carId.length > 0) {
        params = params + '&' + getData['carId'].map((value, index) => `carId=${value}`).join('&'); 
    }
    if (getData.serviceType && getData.serviceType.length > 0) {
        params = params + '&' + getData['serviceType'].map((value, index) => `serviceType=${value}`).join('&'); 
    }
    if (getData.ok_Id && getData.ok_Id != 0) {
        params = params + '&' + `ok_Id=${getData.ok_Id}`; 
    }
    if (getData.desc && getData.desc != 0) {
        params = params + '&' + `desc=${getData.desc}`; 
    }
    
    
    api.get(`/${OPERATE_FILTER}?${ params }`)
        .then(result => { 
          setServices(result.data.operates);
          sethasError(false);
        }) 
        .catch(error => { 
          sethasError(true);
        })
        .finally(() => {
          setIsLoading(false);
        });

    // axios.get(`${BASE_URL}/${OPERATE_FILTER}?${ params }`) 
    //   .then(result => { 
    //       setServices(result.data);
    //       sethasError(false);
    //   }) 
    //   .catch(error => { 
    //     sethasError(true);
    //   })
    //   .finally(() => {
    //     setIsLoading(false);
    // });

    setOpenFilterPage(false);
  }
  

  const getAllServices = () => {
    setIsLoading(true);

    api.get(`${OPERATE_CAR_OPERKIND}`)
        .then((response) => {

          if (response.data.operates) {

            setServices(response.data.operates);

          }
      
          sethasError(false);
        })
        .catch((reason) => {
          sethasError(true);
        })
        .finally(() => {
          setIsLoading(false);
        });
    // axios
    //   .get(`${BASE_URL}/${OPERATE_CAR_OPERKIND}`)
      // .then((response) => {
      //   setServices(response.data);
      //   sethasError(false);
      // })
      // .catch((reason) => {
      //   sethasError(true);
      // })
      // .finally(() => {
      //   setIsLoading(false);
      // });
  };

  useEffect(getAllServices, [isDeleteLoading]);

  const [operKinds, setOperKinds] = useState([]);
  useEffect(() => {


    api.get(`/${OPERKIND_CAR}`)
        .then((res) => setOperKinds(res.data))
        .catch((err) => console.log(err));

    // axios
    //   .get(`${BASE_URL}/${OPERKIND_CAR}`)
    //   .then((res) => setOperKinds(res.data))
    //   .catch((err) => console.log(err));
  }, []);

    ///////////نمایش پیام حذف سرویس
    const dispatch = useDispatch();
    const deleteSuccess = useSelector(selectDeleteOperateSuccessState);
    const message = (msg, type) => {
    if (type === 'warn') toast.warning(msg);
      else toast.success(msg);
    };
    useEffect(() => {
      if (deleteSuccess) {
        message('سرویس مورد نظر با موفقیت حذف گردید.', 'success');
        dispatch(resetDeleteState());
        // closeButtomSheetHandler();   // 👈 حالا بعد از موفقیت ببند
      }
    }, [deleteSuccess, dispatch]);
  
  return (
    <Fragment>
      {isLoading ? (
        <SpinnerWrapper>
          <PuffLoader color="green" loading={isLoading} size={60} />
        </SpinnerWrapper>
      ) : hasError ? (
        <ErrorBox />
      ) : (
        <div className="container py-3">
          <div className="card shadow-sm border-0 rounded-3">
            {/* Header */}
            <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
              <h6 className="mb-0">فهرست سرویس‌ها</h6>
              <button
                onClick={() => setOpenFilterPage(true)}
                type="button"
                className="btn btn-light btn-sm d-flex align-items-center"
              >
                <IoOptionsOutline className="me-1" />
                صافی
              </button>
            </div>
  
            {/* Body */}
            <div className="card-body p-3">
              {services.length === 0 ? (
                  <div
                    className={`alert alert-success text-center shadow-sm p-4 rounded`}
                    role="alert"
                    style={{ maxWidth: "420px", width: "100%" }}
                  >
                    <p>هیچ سرویسی یافت نشد!</p>
                    {/* <Link
                      type="button"
                      className="btn btn-info btn-lg w-100"
                      to={'/add-service'}
                    >
                      سرویس جدید
                    </Link> */}
                  </div>
              ) : (
                <div className="row g-3">
                  {services.map((service, index) => {
                    const result = calculateDateDiff(service);
                    return (
                      <motion.div
                        key={service.id}
                        className="col-12 col-md-6 col-lg-4"
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: index * 0.1 }}
                      >
                        <CardServicesView
                          service={service}
                          min={result.min}
                          max={result.max}
                          now={result.now}
                        />
                      </motion.div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
  
          {/* فیلتر به صورت BottomSheet */}
          <BottomSheet
            isOpen={openFilterPage}
            onClose={() => setOpenFilterPage(false)}
            snapPoint="400"
          >
            <Filter
              cars={cars}
              operKind={operKinds}
              sendDataToParent={handleDataFromChild}
              formCall='operate'
            />
          </BottomSheet>
        </div>
      )}
    </Fragment>
  );  
};

export default ShowAll;
